import React from 'react';

const MoviesRoadmapSection = ({ nextSteps }) => {
  return (
    <section aria-labelledby="movies-roadmap-title" className="mb-20">
      <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-lg site-card">
        <h2 id="movies-roadmap-title" className="text-3xl font-bold text-gray-900">
          Proximos passos do MVP
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          O foco agora e validar a navegacao e a organizacao. Depois a gente pode enriquecer os
          dados.
        </p>
        <ul className="mt-6 space-y-3 text-gray-600 list-disc list-inside">
          {nextSteps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default MoviesRoadmapSection;
